// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
/** Resting internal lamp level, shared by gameplay and the neutral parts preview. */
export const componentStandby=(kind:string|undefined):number=>kind==='popBumper'?.32:kind==='slingshot'?.14:kind===undefined?.10:0
